import React, { useState, useRef, useCallback, useEffect } from 'react';
import { block } from '../utils/cn';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { DotsIcon } from '../icons/DotsIcon';
import { DropdownMenuPopup } from './DropdownMenuPopup';
import './DropdownMenu.css';
const b = block('dropdown-menu');
export const DropdownMenu = ({ items = [], size = 'm', icon = React.createElement(Icon, { data: DotsIcon }), onMenuToggle, hideOnScroll = true, data, disabled, switcher, switcherWrapperClassName, defaultSwitcherProps, defaultSwitcherClassName, onSwitcherClick, menuProps, popupClassName, popupPlacement, children, }) => {
    const [isPopupShown, setPopupShown] = useState(false);
    const anchorRef = useRef(null);
    const handleSwitcherClick = (event) => {
        if (disabled) {
            return;
        }
        onMenuToggle === null || onMenuToggle === void 0 ? void 0 : onMenuToggle();
        onSwitcherClick === null || onSwitcherClick === void 0 ? void 0 : onSwitcherClick(event);
        setPopupShown((value) => !value);
    };
    const handleMenuItemClick = useCallback((event, action) => {
        action(event, data);
        onMenuToggle === null || onMenuToggle === void 0 ? void 0 : onMenuToggle();
        setPopupShown(false);
    }, [data, onMenuToggle]);
    const handleClose = useCallback(() => {
        setPopupShown(false);
        onMenuToggle === null || onMenuToggle === void 0 ? void 0 : onMenuToggle();
    }, [onMenuToggle]);
    const handleScroll = useCallback((event) => {
        if (event.target.contains(anchorRef.current)) {
            onMenuToggle === null || onMenuToggle === void 0 ? void 0 : onMenuToggle();
            setPopupShown(false);
        }
    }, [onMenuToggle]);
    useEffect(() => {
        if (!isPopupShown || !hideOnScroll) {
            return;
        }
        document.addEventListener('scroll', handleScroll, true);
        return () => {
            document.removeEventListener('scroll', handleScroll, true);
        };
    }, [isPopupShown, hideOnScroll, handleScroll]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: anchorRef, className: b('switcher-wrapper', switcherWrapperClassName), onClick: handleSwitcherClick }, switcher || (React.createElement(Button, Object.assign({ view: "flat", size: size }, defaultSwitcherProps, { className: b('switcher-button', defaultSwitcherClassName), disabled: disabled }), icon))),
        React.createElement(DropdownMenuPopup, { popupClassName: popupClassName, items: items, open: isPopupShown, size: size, placement: popupPlacement, menuProps: menuProps, anchorRef: anchorRef, onMenuItemClick: handleMenuItemClick, onClose: handleClose }, children)));
};
